import axios from '@axios'

export default {
  list: () => axios.get(`${process.env.VUE_APP_WCOND_API}/telefones`),
}
